import { Card, Link } from '@postenbring/hedwig-react';


export const ColoredBanner = ({ heading, imgAltText, imgUrl, linkText, linkIsExternal, text, target, url }) => (
  <Card variant="miniature" className='hds-mb-20-24'>
    {imgUrl &&
      <Card.Media>
        <Card.MediaImg src={imgUrl} alt={imgAltText} />
      </Card.Media>
    }
    <Card.Body>
      {heading &&
        <Card.BodyHeader as="h2">
          <Card.BodyHeaderTitle>{heading}</Card.BodyHeaderTitle>
        </Card.BodyHeader>
      }
      {
        text && <Card.BodyDescription>{text}</Card.BodyDescription>
      }
      <Card.BodyAction asChild>
        <Link href={url} variant="solid" target={target}>
          <Card.BodyActionArrow direction={linkIsExternal ? "up-right" : "right"} />
          {linkText}
        </Link>
      </Card.BodyAction>
    </Card.Body>
  </Card>
)
